module.exports = __webpack_public_path__ + "static/media/vinefinder1.bb6ce9dd.png";